export default {
  mounted () {
    window.addEventListener('beforeunload', this.beforeUnloadHandler, false)
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler, false)
  },
  methods: {
    beforeUnloadHandler (event) {
      // 必须要这段代码阻止默认行为，提示的弹窗才会出来
      event.preventDefault()
      event.returnValue = ''
    }
  }
}
